import moment from 'moment';

export interface IFilter {
  date: string[];
  id: number[];
  invoice_id: string[];
  customer_email: string;
}

export const initialValues: IFilter = {
  date: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
  id: [],
  invoice_id: [],
  customer_email: '',
};
